<template>
  <div class="admin-edit-template px-2 px-md-4 py-2 py-md-4">
    <TemplateDetail
      scope="admin"
      :templateId="$route.params.templateId"
    />
  </div>
</template>

<script>
/* eslint-disable */
import TemplateDetail from "@/components/message_templates/TemplateDetail.vue"
export default {
  name: "AdminEditTemplate",
  components: {
    TemplateDetail,
  },
};
</script>

<style lang="scss">
.admin-edit-template {
  width: 100%;
  height: 100%;
}
</style>
